/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type infoUpdateContainerInput = {
    clientMutationId?: string | null;
    slug: string;
    profileImageSlug?: string | null;
    containerNumber: string;
    voyageSlug: string;
    containerType: string;
    containerSize?: string | null;
    procedure?: string | null;
    atb?: string | null;
    bookingNumber?: string | null;
    turninLocationSlug?: string | null;
    pickupLocationSlug?: string | null;
    pickupReference?: string | null;
    turninReference?: string | null;
    pickupComment?: string | null;
    billOfLadingNumber?: string | null;
    terminalDate?: string | null;
    dischargeDate?: string | null;
    latestPickupDate?: string | null;
    pickupDate?: string | null;
    latestTurninDate?: string | null;
    thcPaidDate?: string | null;
    linkedContacts: Array<LinkedContactInput>;
    shippingLineSlug: string;
};
export type LinkedContactInput = {
    role: string;
    contactSlug: string;
};
export type ContainerReleaseConfirmMutationVariables = {
    input: infoUpdateContainerInput;
};
export type ContainerReleaseConfirmMutationResponse = {
    readonly infoUpdateContainer: {
        readonly clientMutationId: string | null;
    } | null;
};
export type ContainerReleaseConfirmMutation = {
    readonly response: ContainerReleaseConfirmMutationResponse;
    readonly variables: ContainerReleaseConfirmMutationVariables;
};



/*
mutation ContainerReleaseConfirmMutation(
  $input: infoUpdateContainerInput!
) {
  infoUpdateContainer(input: $input) {
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "infoUpdateContainerPayload",
    "kind": "LinkedField",
    "name": "infoUpdateContainer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ContainerReleaseConfirmMutation",
    "selections": (v1/*: any*/),
    "type": "ApplicationCommand",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ContainerReleaseConfirmMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "8b9378d57a3b41d50eec885cfbccf37f",
    "id": null,
    "metadata": {},
    "name": "ContainerReleaseConfirmMutation",
    "operationKind": "mutation",
    "text": "mutation ContainerReleaseConfirmMutation(\n  $input: infoUpdateContainerInput!\n) {\n  infoUpdateContainer(input: $input) {\n    clientMutationId\n  }\n}\n"
  }
};
})();
(node as any).hash = '1ca65992ec29cc3cad3721f84019a45f';
export default node;
